export default __webpack_public_path__ + "static/media/googleFav2.4ff9a5f6.png";